import { apiClient } from "../../../services/axiosInstance";
import {
  Section,
  ServerListResponse,
  ServerSingleResponse,
} from "../../../types";

export function getSection(
  slug: string,
  params?: { page?: number; perpage?: number; q?: string },
) {
  const qs = new URLSearchParams();
  if (params?.page) qs.set("page", String(params.page));
  if (params?.perpage) qs.set("perpage", String(params.perpage));
  if (params?.q) qs.set("q", params.q);
  const suffix = qs.toString();
  return apiClient.get<ServerSingleResponse<Section>>(
    `/v1/cms-sections/${slug}${suffix ? `?${suffix}` : ""}`,
  );
}
export function getSections(
  activeChannel: string,
  pageParam?: number,
  signal?: AbortSignal,
) {
  return apiClient.get<ServerListResponse<Section>>(
    `/v1/cms/${activeChannel}/sections${pageParam ? "?p=" + pageParam : ""}`,
    { signal },
  );
}

export const GET_SECTIONS_QUERY_KEY = "sections";
